import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../app/store";
import { AppState, AppStateType } from "../enums/appState.enum";
import { doLoginParametersBuilder } from "../reduxAsyncThunks/login.thunks";

export interface ParametersState {
  appState: AppStateType;
  started: boolean;
  serverError: boolean;
  unknownUser: boolean;
}

interface UpdateParametersPayload {
  appState: AppStateType;
  started: boolean;
}

const initialState: ParametersState = {
  appState: AppState.ABIERTO,
  started: false,
  serverError: false,
  unknownUser: false,
};

export const parametersSlice = createSlice({
  name: "parameters",
  initialState,
  reducers: {
    updateParametersData: (state, action: PayloadAction<UpdateParametersPayload>) => {
      state.appState = action.payload.appState;
      state.started = action.payload.started;
    },
    setServerError: (state, action) => {
      state.serverError = action.payload;
    },
    setUnknownUser: (state, action) => {
      state.unknownUser = action.payload;
    },
  },
  extraReducers: (builder) => {
    doLoginParametersBuilder(builder);
  },
});

export const selectParameter = (state: RootState) => state.parameters;

export const { updateParametersData, setServerError, setUnknownUser } = parametersSlice.actions;

export default parametersSlice.reducer;
